export default __webpack_public_path__ + "static/media/right_arrow_green.2af612eb.svg";